import Vue from 'vue'
import Vuex from 'vuex'
import { io } from '@/js/cyb_data_model'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ioh: new io(null),
    special_day: true,
    hidden_menu: true,
    theme_mixed: false
  },

  mutations: {
    changeSpecialDay(state, val){
      state.special_day = val
    },
    changeHiddenMenu(state, val){
      state.hidden_menu = val
    },
    changeThemeMixed(state, val){
      state.theme_mixed = val
    }
  },
  actions: {
    getData(){
      this.state.special_day = Vue.prototype.$user.special_day
      this.state.hidden_menu = Vue.prototype.$user.hidden_menu
      this.state.theme_mixed = Vue.prototype.$user.theme_mixed
    }
  },
  modules: {
  }
})
